import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ReactQuill from "react-quill";

function FormField({ label, ...rest }) {
  return <MDInput {...rest} label={label} variant="standard" fullWidth />;
}

FormField.propTypes = {
  label: PropTypes.string.isRequired,
};

function AddNewCategory() {
  const navigate = useNavigate();
  const [categoryData, setCategoryData] = useState({
    name: "",
    description: "",
    plainDescription: ""
  });

  const updateCategoryData = (field, value) => {
    setCategoryData((prev) => ({ ...prev, [field]: value }));
  };
  const handleDescriptionChange = (value, delta, source, editor) => {
    updateCategoryData("description", value); // Keep HTML in state
    const plainText = editor.getText(); // Extract plain text (no HTML)
    updateCategoryData("plainDescription", plainText.trim()); // Store plain text
  };

  const handleSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append("name", categoryData.name);
      formData.append("description", categoryData.description);
      formData.append("plainDescription", categoryData.plainDescription);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V2/category/categories`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      Swal.fire({
        title: "Success!",
        text: "The category has been added successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      navigate("/dashboard/6-categories/categories-page");
      console.log("Response:", response.data);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Failed to add the category.",
        icon: "error",
        confirmButtonText: "OK",
      });
      console.error("Error:", error.response.data);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={8} textAlign="center">
        <MDTypography variant="h3" fontWeight="bold">
          Add New Category
        </MDTypography>
        <MDTypography variant="h5" fontWeight="regular" color="secondary">
          This information will describe more about the Category.
        </MDTypography>
      </MDBox>
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="medium">
                  Category Details
                </MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12}>
                    <FormField
                      type="text"
                      label="Name"
                      value={categoryData.name}
                      onChange={(e) =>
                        updateCategoryData("name", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <ReactQuill
                      value={categoryData.description}
                      onChange={handleDescriptionChange}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
            <MDBox mt={3} display="flex" justifyContent="flex-end">
              <MDButton
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                Publish
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddNewCategory;
